import { NumberFormat } from '@billy/design-system'

export const formatDepositCurrencyAmount = (amount: number, currency: string, locale: string): string =>
  NumberFormat.getCurrencyNumber(amount, currency, locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
